/* =====================================================================
   El menú del carril `ventaja`
   =====================================================================
   Sus dos pantallas se montan solas desde aquí. Antes vivían dentro de
   `ui/modulos.jsx`, que es el archivo caliente del cliente: 55 imports y
   medio centenar de entradas, y todo el que añade una pantalla escribe
   su línea ahí. El enganche existe para que nadie tenga que hacerlo.

   =====================================================================
   POR QUE LOS `id` LLEVAN PREFIJO, Y QUE COSTO TUVO PONERSELO
   =====================================================================
   `agregar()` revienta si dos carriles declaran el mismo `id`: la
   consola busca por `id` y se queda con el primero, así que el segundo
   existiría en el menú y llevaría a la pantalla del otro. Con
   «parametros» a secas ese choque era cuestión de tiempo — es de los
   nombres que cualquier carril iba a querer.

   Cambiar un `id` NO es gratis y conviene que quede escrito: es lo que
   viaja en la barra de direcciones (`?m=<id>`, ver `lib/urlEstado.js`) y
   es lo que el asistente usa para el botón «abrir esta pantalla»
   (`modulo=` en `backend/app/documentacion.py`). Las dos referencias del
   manual se actualizaron en el mismo commit; un enlace guardado de antes
   del 4 de septiembre de 2026 aterriza en la pantalla de inicio, que es
   lo que hace la consola cuando no reconoce un módulo.

   =====================================================================
   POR QUE UN GRUPO PROPIO Y NO LOS DE ANTES
   =====================================================================
   «Dinero en la mesa» vivía en **Operación** y «Parámetros comerciales»
   en **Administración**. No se pueden conservar esos sitios desde aquí:
   `modulos.jsx` hace `[...GRUPOS_BASE, ...gruposDeCarriles()]`, así que
   lo que traiga un carril se AÑADE al final; declarar un grupo que ya
   existe pintaría dos encabezados con el mismo nombre —y `BarraLateral`
   los lleva por `key={g.grupo}`, que además es una clave repetida en
   React.

   Así que las dos bajan juntas a un grupo con nombre propio, al final
   del menú. Es un cambio de sitio real y se dice en la ENTREGA: quien
   las buscara donde estaban ayer ya no las encuentra ahí. Juntarlas no
   es un consuelo — las dos hablan de lo mismo, que es con qué números se
   negocia con un proveedor y qué se le puede cobrar cuando falla.

   Si el enganche llegara a saber fundir un grupo con el del mismo nombre
   de `GRUPOS_BASE`, las dos volverían a sus sitios sin tocar este
   archivo. Está pedido en la ENTREGA; `carriles/index.js` es del
   integrador.
   ===================================================================== */
import { Coins, Handshake } from 'lucide-react';

import DineroEnLaMesa from '../paginas/DineroEnLaMesa';
import ParametrosComerciales from '../paginas/ParametrosComerciales';

export default {
  orden: 40,
  grupos: [{
    grupo: 'Compras y proveedores',
    items: [
      /* SE VE CON EL MINIMO DE ENCARGADO Y SE DECIDE CON PERMISO. Mirar
         lo que se está perdiendo es lo que hace que alguien reclame;
         esconderlo detrás del permiso de decidir garantiza que nadie lo
         mire. El permiso `cargos_a_proveedor` gobierna los botones de
         confirmar y descartar, dentro de la pantalla. */
      { id: 'ventaja-dinero-en-la-mesa', etiqueta: 'Descuentos de proveedor sin cobrar',
        icono: Coins, min: 'ENCARGADO', soloEmpresa: true,
        Comp: DineroEnLaMesa },

      /* POR PERMISO, no por rango: `parametros_comerciales` se le puede
         dar a quien lleva las compras sin darle además la gestión de
         usuarios y de sucursales. */
      { id: 'ventaja-parametros', etiqueta: 'Reglas de compra',
        icono: Handshake, permiso: 'parametros_comerciales', min: 'ADMIN',
        soloEmpresa: true, Comp: ParametrosComerciales },
    ],
  }],
};
